/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentChartConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AiAgentChartConfiguration");
    }

    getFixupPrototypeFunction() { return AiAgentChartConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AiAgentChartConfiguration>): AiAgentChartConfiguration {
        let obj = Object.assign(new AiAgentChartConfiguration(), model);
        AiAgentChartConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentChartConfiguration>): AiAgentChartConfiguration {
        if (!model) return null;
        return AiAgentChartConfiguration.newInstance(<AiAgentChartConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentChartConfiguration) {
        if (!obj) return;

        models.AiAgentChartConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentChartConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiAgentChartConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
